import React, { useEffect, useState, useContext } from 'react'
import { useRoutes } from 'react-router-dom'
import SecureRoutes from '../../routes/SecureRoutes/SecureRoutes'
import TopNav from './TopNav/TopNav'
import { store } from '../../context/StateProvider'
import StorageService from '../../services/session/storage.service'
import ThemeService from '../../services/api/theme.service'

import { Amplify, Auth, PubSub, API } from 'aws-amplify';
import { AWSIoTProvider } from '@aws-amplify/pubsub/lib/Providers';
import Utilities from "./../../services/commonservice/utilities";
import toast, { ToastBar, Toaster, ToastIcon } from 'react-hot-toast'

import AppSetting from './../../common/constants/appsetting.constant';

import LogRocket from 'logrocket';

const AppFrame = (props) => {
  let routes = useRoutes(SecureRoutes)
  const globalStateAndDispatch = useContext(store)
  const state = globalStateAndDispatch.state
  const dispatch = globalStateAndDispatch.dispatch

  const [isSubscribed, setIsSubscribed] = useState(false)
  const [subscribedTopic, setSubscribedTopic] = useState('')
  const [subscription, setSubscription] = useState(null)
  const [iotProviderConfigured, setIotProviderConfigured] = useState(false)

  async function configurePubSub() {
    console.log("AppSetting.iotEndpoint "+AppSetting.iotEndpoint)
    if (!iotProviderConfigured) {
      Amplify.configure({
        Auth: {
          identityPoolId: AppSetting.identityPoolId,
          region: AppSetting.region,
        },
      });

      Amplify.addPluggable(new AWSIoTProvider({
        aws_pubsub_region: AppSetting.region,
        aws_pubsub_endpoint: AppSetting.iotEndpoint,
      }));
      setIotProviderConfigured(true);
    }
  }
  
  function subscribeToTopic() {

    if (!state.providerId)
    {
      if (isSubscribed) {
        subscription.unsubscribe();
        setIsSubscribed(false);
        setSubscribedTopic('');
      }
    }
    else
    {
      if (isSubscribed) {
        subscription.unsubscribe();
        console.log(`Unsubscribed from ${subscribedTopic}`);
        setIsSubscribed(false);
        setSubscribedTopic('');
      }
      if (state.providerId != '0rbd3W69') {
        setSubscription(PubSub.subscribe(state.providerId).subscribe({
          next: data => handleReceivedMessage(data),
          error: error => console.error(error),
          close: () => {
            console.log('Done');
            subscribeToTopic();
          },
        }));
        setIsSubscribed(true);
        setSubscribedTopic(state.providerId);
        console.log(`Subscribed to IoT topic ${state.providerId }`);
      }
    }
   
  }

  function handleReceivedMessage(data) {

    // Received messages contain the topic name in a Symbol that we have to decode: 
    const symbolKey = Reflect.ownKeys(data.value).find(key => key.toString() === 'Symbol(topic)');
    const publishedTopic = data.value[symbolKey];
    const message = data.value;

    toast.success("New text message");

    Utilities.trigger("patientAlert",message);

    console.log(`Message received on ${publishedTopic}:`, message);
  }  

  useEffect(() => {
    // Restore admin session if available (for refresh scenarios)
    const isEmulatedTab = window.name && window.name.startsWith('emulated-tab-');
    let themeApplied = false;
    
    if (!isEmulatedTab) {
      // This is main admin tab - restore backup if session is lost
      const currentAuth = StorageService.get('session', 'auth');
      if (!currentAuth) {
        const adminAuth = StorageService.get('local', 'adminSessionBackup_auth');
        const adminUserDetails = StorageService.get('local', 'adminSessionBackup_userDetails');
        const adminSettingsData = StorageService.get('local', 'adminSessionBackup_settingsData');
        const adminProviderSelected = StorageService.get('local', 'adminSessionBackup_providerSelected');
        const adminModuleDetails = StorageService.get('local', 'adminSessionBackup_moduleDetails');
        const adminLocale = StorageService.get('local', 'adminSessionBackup_locale');
        
        if (adminAuth) {
          StorageService.save('session', 'auth', adminAuth);
          if (adminUserDetails) StorageService.save('session', 'userDetails', adminUserDetails);
          if (adminSettingsData) StorageService.save('session', 'settingsData', adminSettingsData);
          if (adminProviderSelected) StorageService.save('session', 'providerSelected', adminProviderSelected);
          if (adminModuleDetails) StorageService.save('session', 'moduleDetails', adminModuleDetails);
          if (adminLocale) StorageService.save('session', 'locale', adminLocale);
        }
      }
    }
    
    let newState = { ...state }

    let userDetails = JSON.parse(StorageService.get("session", "userDetails"))
    if (userDetails) newState.providerSelected = userDetails;
    
    let providerSelected = JSON.parse(StorageService.get("session", "providerSelected"))
    let skinData = providerSelected && { logo: providerSelected.logo, skin: providerSelected.skin, providerName: providerSelected.providerUrlSuffix } || null
    if (skinData) {
      newState.skinData = skinData;
    }

    let settingsData = JSON.parse(StorageService.get("session", "settingsData"))
    if (settingsData) {
      newState.settingsData = settingsData;
    }

    let locations = JSON.parse(StorageService.get("session", "locale"))
    if (locations) {
      newState.practiceLocations = locations
      newState.practiceLocationId = locations[0].practiceLocationId
    }

    let permissions = JSON.parse(StorageService.get("session", 'permissions'))
    newState.permissions = permissions;

    // Apply theme ONCE at the end based on user type
    if (userDetails) {
      const userType = userDetails.userType;
      
      if (userType === 2) {
        // Global admin always uses default theme (7)
        ThemeService.changeTheme(7);
      } else if (userType === 1) {
        // Provider admin uses their practice theme
        if (settingsData && settingsData.skin) {
          ThemeService.changeTheme(settingsData.skin);
        } else if (skinData && skinData.skin) {
          ThemeService.changeTheme(skinData.skin);
        } else {
          ThemeService.changeTheme(7);
        }
      } else if (userType === 0) {
        // Patient uses their theme if available
        if (settingsData && settingsData.skin) {
          ThemeService.changeTheme(settingsData.skin);
        } else {
          ThemeService.changeTheme(7);
        }
      } else {
        // Default fallback
        ThemeService.changeTheme(7);
      }
    }

    return dispatch({ type: 'setAll', payload: newState })
  }, []);

  useEffect(() => {
      configurePubSub();
      subscribeToTopic();

      if (state.providerId && ['6RWPoQ1A'].includes(state.providerId) ) {

        if (
          window.location.host.includes("hpt-2.0-prd") ||
          window.location.host.includes("hpt-2.0-staging") ||
          window.location.host.includes("v2.hellopatients") ||
          window.location.host.includes("admin.hellopatients") ||
          window.location.host.includes("login.hellopatients") ||
          window.location.host.includes("v2.revique") ||
          window.location.host.includes("admin.revique") ||
          window.location.host.includes("login.revique")
        ) {
          var userDetails = JSON.parse(StorageService.get("session", 'userDetails'));

          if (state?.isEmulate) {
            // LogRocket.init('jbnkfa/revique');
            // var identity = userDetails.userName;
            // var providerName = state?.skinData?.providerName;
            // if (providerName) identity = providerName+'/'+identity
            // LogRocket.identify('emulate/'+identity)
          }
          else {
            LogRocket.init('jbnkfa/revique');
            var identity = userDetails.userName;
            var providerName = state?.skinData?.providerName;
            if (providerName) identity = providerName+'/'+identity
            LogRocket.identify(identity)
          }
        }        
      }

  },[state.providerId]);

  return (
    <div>
      <TopNav />
      <div className="appframe">{routes}</div>
    </div>
  )
}

export default AppFrame